import { render, staticRenderFns } from "./BackOffice.vue?vue&type=template&id=1c6e2a8d&"
import script from "./BackOffice.vue?vue&type=script&lang=js&"
export * from "./BackOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports